import { useState, useRef } from "react";
import { Menu, X, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAcervoOpen, setIsAcervoOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsAcervoOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsAcervoOpen(false);
    }, 300);
  };

  const acervoItems = [
    { name: "Libros Cinematográficos", href: "/guiones" },
    { name: "Obra Dirigida y Producida", href: "/obra-producida" },
    { name: "Proyectos y Series", href: "/proyectos-series" },
    { name: "Argumentos y Sipnopsis", href: "/argumentos" },
    { name: "Cortometrajes", href: "/cortometrajes" },
    { name: "Cooperativas", href: "/cooperativas" },
    { name: "Televisión y Radio", href: "/television-radio" },
    { name: "Audios de Entrevistas", href: "/audios" },
    { name: "Literatura, Teatro, Poesía y Música", href: "/teatro" },
    { name: "Rojo Amanecer", href: "/fuentes-rojo-amanecer" },
  ];

  return (
    <nav className="fixed top-0 w-full bg-gradient-to-br from-[hsl(var(--footer-gradient-start))] via-[hsl(var(--footer-gradient-mid))] to-[hsl(var(--footer-gradient-end))] backdrop-blur-xl z-50 border-b border-border shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-4 cursor-pointer">
            <div className="flex-shrink-0">
              <img
                className="h-10 w-10"
                src="https://uytprdclntuhcnslrkja.supabase.co/storage/v1/object/public/obra-producida-imagenes/Logo%20El%20Principio%201920x1440.png"
                alt="El Principio Cine y Cultura"
              />
            </div>
            <div className="hidden lg:block">
              <span className="text-xl font-light text-foreground">El Principio Cine y Cultura</span>
            </div>
            <div className="hidden md:block lg:hidden">
              <span className="text-lg font-light text-foreground">El Principio</span>
            </div>
          </Link>

          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <Link
                to="/"
                className="text-foreground/70 hover:text-foreground px-3 py-2 text-sm font-medium transition-colors duration-200"
              >
                Inicio
              </Link>

              {/* Acervo Dropdown */}
              <div className="relative">
                <button
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  className="text-foreground/70 hover:text-foreground px-3 py-2 text-sm font-medium transition-colors duration-200 flex items-center gap-1"
                >
                  Acervo
                  <ChevronDown className="w-4 h-4" />
                </button>

                {isAcervoOpen && (
                  <div
                    className="absolute left-0 mt-0 w-56 bg-gradient-to-br from-[hsl(var(--footer-gradient-start))] via-[hsl(var(--footer-gradient-mid))] to-[hsl(var(--footer-gradient-end))] rounded-lg shadow-lg border border-border z-50"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <div className="py-2">
                      {acervoItems.map((item) => (
                        <Link
                          key={item.name}
                          to={item.href}
                          className="block px-4 py-2 text-sm text-foreground/70 hover:bg-muted hover:text-foreground transition-colors duration-200"
                          onClick={() => setIsAcervoOpen(false)}
                        >
                          {item.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <Link
                to="/contacto"
                className="bg-golden text-golden-foreground px-4 py-2 text-sm font-medium rounded-lg hover:bg-golden/90 transition-colors duration-200"
              >
                Contacto
              </Link>
            </div>
          </div>

          <div className="md:hidden flex items-center">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-foreground/70 hover:text-foreground p-2">
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-gradient-to-br from-[hsl(var(--footer-gradient-start))] via-[hsl(var(--footer-gradient-mid))] to-[hsl(var(--footer-gradient-end))] border-t border-border">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link
              to="/"
              className="text-foreground/70 hover:text-foreground block px-3 py-2 text-base font-medium"
              onClick={() => setIsMenuOpen(false)}
            >
              Inicio
            </Link>

            {/* Mobile Acervo Section */}
            <div className="px-3 py-2">
              <div className="text-foreground font-medium text-base mb-2">Acervo</div>
              <div className="pl-4 space-y-1">
                {acervoItems.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="text-foreground/60 hover:text-foreground block py-1 text-sm"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>

            <Link
              to="/contacto"
              className="bg-golden text-golden-foreground block px-3 py-2 mx-2 mt-2 text-base font-medium rounded-lg hover:bg-golden/90 transition-colors duration-200 text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              Contacto
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
